import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const DomainName = styled.div`
  padding: 16px 20px;
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  background: ${Colors.GS200};
`

export const Description = styled.div`
  color: var(--text-primary);
  font-family: var(--font-family-body, "Suisse Int'l");
  font-size: var(--font-size-400, 16px);
  font-style: normal;
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--font-line-height-400, 24px); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal, 0);
`
